export default __webpack_public_path__ + "static/media/bell.3ab840ba.svg";